<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <Input type="textarea" v-model="model.val"
      :autosize="{minRows: 2,maxRows: 5}">
    </Input>
  </FormItem>
</template>

<script>
export default {
  name: 'long-element',
  data: function () {
    return {
      newVal: this.model.val
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.val.val
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
    editVal: function () {
      this.$emit('editVal', this.model, this.newVal)
    }
  }
}
</script>
